<template>
    <div class="clipboard-container d-flex align-items-center">
        <div class="clipboard-text">
            <p>{{ value ? value : placeholder }}</p>
        </div>
        <button class="clipboard-button button button--primary" @click="copyText">Copy</button>
    </div>
</template>

<script>

    export default {
        props: {
            placeholder: {
                type: String,
                default: ''
            },
            value: {
                type: String,
                default: ''
            },
        },
        methods: {
            async copyText() {
                try {
                    await navigator.clipboard.writeText(this.value);
                    this.$toasted.show("The text has been copied!", {
                        className: "success-class",
                        icon: "check-circle",
                    });
                } catch (err) {
                    console.error(err);
                    this.$toasted.show("Unexpected error!", {
                        icon: 'times-circle',
                        className: 'error-class'
                    });
                }
            }
        },
    };
</script>

<style scoped>
    .clipboard-container {
        gap: 10px;
        border-radius: 10px;
        overflow: hidden;
        width: 100%;
        background-color: #2d2d2d;
    }
    .clipboard-text {
        box-sizing: border-box;
        padding: 0 5px 0 10px;
        width: 100%;
        overflow: hidden;
    }
    .clipboard-text p {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis
    }
    .clipboard-button {
        border-radius: 0;
        padding: 5px 10px;
    }
</style>